module.exports = __webpack_public_path__ + "img/business_03.e80fb37d.jpg";